export default __webpack_public_path__ + "static/media/download.5559ef40.svg";